function getJobGroupIdAndUserId(ctx) {
  const { queueJob: { jobGroupId = null } = {}, user: { id: userId = null } = {} } = ctx;
  return { jobGroupId, userId };
}

module.exports = getJobGroupIdAndUserId;
